import { gql } from "@apollo/client";

export const UPDATE_CUIDADOS_PALIATIVOS = gql`
    mutation UpdateCuidadosPaliativosRI(
        $screen: Int!
        $input: AddCuidadosPaliativosRIInput!)
    {
        createAndUpdateCuidadosPaliativosRI(
            screen: $screen
            input: $input
        ){
            idCuidadosPaliativosRI
        }
    }
`;